import type React from 'react';
import { lazy } from 'react';
import type ReactQuill from 'react-quill-new';
import { LazyDependency } from './LazyDependency.tsx';

// type-only import, erased at build time — it does not pull Quill into this chunk
export type RichTextEditorProps = Omit<React.ComponentProps<typeof ReactQuill>, 'modules' | 'formats' | 'theme'> & {
  ref?: React.Ref<ReactQuill>;
};

const LazyRichTextEditorImpl = lazy(() => import('./RichTextEditorImpl.tsx'));

/**
 * Quill is ~140 kB and only used by the two news/basedata editors in the admin area.
 * Props (including the antd Form.Item value/onChange injection and the ref callers use to
 * reach `editor`) are forwarded verbatim.
 */
export const RichTextEditor: React.FC<RichTextEditorProps> = props => (
  <LazyDependency height="200px">
    <LazyRichTextEditorImpl {...props} />
  </LazyDependency>
);
